import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';
import '../CSS/Modal.css';

const EmailFormModal = ({ isOpen, onClose, orgName }) => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();
    emailjs
      .sendForm('service_dhgtf7o', 'template_2oqlyys', form.current, 'CSxb2cjoKlU_BpSCG')
      .then(() => {
        form.current.reset();
        onClose();
      })
      .catch((error) => console.log(error.text));
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      {/* add shared scoped class so styles apply identically everywhere */}
      <div className="modal-content orion-modal">
        <h2>Contact Us</h2>
        <form ref={form} onSubmit={sendEmail} className="email-form">
          <div className="form-row-modal">
            <label className="form-label-modal">Reason for Contact:</label>
            <input
              type="text"
              name="reason"
              className="form-input-modal"
              value="Profile – Organization"
              readOnly
            />
          </div>

          <div className="form-row-modal">
            <label className="form-label-modal">Name:</label>
            <input type="text" name="user_name" className="form-input-modal" required />
          </div>

          <div className="form-row-modal">
            <label className="form-label-modal">Email:</label>
            <input type="email" name="user_email" className="form-input-modal" required />
          </div>

          <div className="form-row-modal">
            <label className="form-label-modal">Company:</label>
            <input type="text" name="company" className="form-input-modal" required />
          </div>

          <div className="form-row-modal">
            <label className="form-label-modal">Deadline:</label>
            <input type="text" name="deadline" className="form-input-modal" required />
          </div>

          <div className="form-row-modal">
            <label className="form-label-modal">Subject:</label>
            <input
              type="text"
              name="subject"
              className="form-input-modal"
              defaultValue={`Profile Creation - ${orgName}`}
              required
            />
          </div>

          <div className="form-row-modal">
            <label className="form-label-modal">Message:</label>
            <textarea
              name="message"
              className="form-textarea-modal"
              rows={6}
              defaultValue={`Hello,

I would like a profile of ${orgName} created.

Thank you`}
              required
            />
          </div>

          <div className="form-actions">
            <button type="submit" className="form-submit">Send</button>
            <button type="button" className="form-cancel" onClick={onClose}>Cancel</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EmailFormModal;
